import axios from 'axios';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import ProductImageForIndex from './product_image_for_index';
import StoreBadges from '../common/store_badges';
import ProductImageCropForIndex from './product_image_crop_for_index';
import karteErrorClient from '../common/karte/error';

document.addEventListener('DOMContentLoaded', () => {
  const indexDiv = document.getElementById('store_products_index') || document.getElementById('store_products_index_for_group');
  if (indexDiv == null) {
    return;
  };

  const productImageForIndexClient = new ProductImageForIndex();
  const productImageCropForIndexClient = new ProductImageCropForIndex();
  const storeBadgesClient = new StoreBadges();
  const updateStoreProductModal = document.getElementById('update_store_product_modal') as HTMLElement;
  const cropperModal = document.getElementById('store_product_cropper') as HTMLElement;
  const checkBoxTds = indexDiv.querySelectorAll('td.check-box');
  const checkBoxThs = indexDiv.querySelectorAll('th.check-box');
  const productImages = document.querySelectorAll('td.product-image');

  type resultStoreProduct = { result: string };

  indexDiv.addEventListener('drop', (event) => {
    event.preventDefault();
  });

  indexDiv.addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
  });

  const toggleBulkToolbars = () => {
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      const toolbar = form.querySelector('.store-products-bulk-toolbar') as HTMLElement;
      const checkedBoxes = form.querySelectorAll('.store-product-id-check-box:checked');
      if (toolbar == null) {
        return;
      }

      if (checkedBoxes.length == 0) {
        toolbar.style.display = 'none';
      } else {
        toolbar.style.display = 'block';
      }
    });
  };

  const addEventToCheckBoxTds = (checkBoxTds: NodeListOf<Element>) => {
    checkBoxTds.forEach(checkBoxTd => {
      const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
      checkBoxTd.addEventListener('click', (e) => {
        if ((e.target as HTMLElement).tagName != 'INPUT') {
          checkbox.click();
        }
      });
    });
  };

  const addEventToCheckBoxThs = (checkBoxThs: NodeListOf<Element>) => {
    checkBoxThs.forEach(checkBoxTh => {
      const checkbox = checkBoxTh.querySelector('input') as HTMLInputElement;
      checkBoxTh.addEventListener('click', (e) => {
        if ((e.target as HTMLElement).tagName != 'INPUT') {
          checkbox.click();
        }
      });
    });
  };

  const addEventToAllCheckBoxes = () => {
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      const checkboxes = form.querySelectorAll('.store-product-id-check-box');
      addEventToAllCheckBoxesForToggleBulkToolbars(checkboxes);

      const allCheckBox = form.querySelector('.all-check-for-store-product-ids');
      if (allCheckBox == null) {
        return;
      }
      (allCheckBox as HTMLElement).addEventListener('change', () => {
        toggleAllCheckBoxes((allCheckBox as HTMLElement), checkboxes);
        if ((allCheckBox as HTMLInputElement).checked) {
          // もっとみるをクリック
          const storeProductGroupMore = form.querySelector('.store-product-group-more') as HTMLElement;
          if (storeProductGroupMore != null) {
            storeProductGroupMore.click();
          }
        }
        toggleBulkToolbars();
      });
    });
  };

  const addEventToAllCheckBoxesForToggleBulkToolbars = (checkboxes: NodeListOf<Element>) => {
    // チェックボックスがクリックされるごとに実行
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        toggleBulkToolbars();
      });
    });
  };

  const addEventToTableColumnToggles = () => {
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      addEventToTableColumnToggle(form);
    });
  }

  const addEventToTableColumnToggle = (targetDiv: HTMLElement) => {
    const tableColumnToggleShow = targetDiv.querySelector('.store-products-column-toggle-show') as HTMLElement;
    const tableColumnToggleHide = targetDiv.querySelector('.store-products-column-toggle-hide') as HTMLElement;
    const ths = targetDiv.querySelectorAll('th.default-hidden');
    const tds = targetDiv.querySelectorAll('td.default-hidden');

    if (tableColumnToggleShow == null || tableColumnToggleHide == null) {
      return;
    }

    tableColumnToggleShow.addEventListener('click', () => {
      ths.forEach(th => {
        (th as HTMLElement).style.display = 'table-cell';
      });
      tds.forEach(td => {
        (td as HTMLElement).style.display = 'table-cell';
      });

      tableColumnToggleHide.style.display = 'flex';
      tableColumnToggleShow.style.display = 'none';

      // classを付与
      targetDiv.classList.add('all-shown')
    });

    tableColumnToggleHide.addEventListener('click', () => {
      ths.forEach(th => {
        (th as HTMLElement).style.display = 'none';
      });
      tds.forEach(td => {
        (td as HTMLElement).style.display = 'none';
      });

      tableColumnToggleShow.style.display = 'flex';
      tableColumnToggleHide.style.display = 'none';

      // classを削除
      targetDiv.classList.remove('all-shown')
    });
  };

  const initializeTableColumnToggle = (targetDiv: HTMLElement) => {
    const tableColumnToggleHide = targetDiv.querySelector('.store-products-column-toggle-hide') as HTMLElement;
    const ths = targetDiv.querySelectorAll('th.default-hidden');
    const tds = targetDiv.querySelectorAll('td.default-hidden');

    if (tableColumnToggleHide.style.display == 'flex') {
      ths.forEach(th => {
        (th as HTMLElement).style.display = 'table-cell';
      });
      tds.forEach(td => {
        (td as HTMLElement).style.display = 'table-cell';
      });
    }
  };

  const toggleAllCheckBoxes = (allCheckBox: HTMLElement, checkboxes: NodeListOf<Element>) => {
    if ((allCheckBox as HTMLInputElement).checked) {
      checkboxes.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = true;
      });
    } else {
      checkboxes.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = false;
      });
    }
    toggleBulkToolbars();
  };

  const addEventToProductImages = (productImages: NodeListOf<Element>) => {
    productImages.forEach(productImage => {
      const fileInput = (productImage as HTMLElement).querySelector('input') as HTMLInputElement;
      const removeImageButton = (productImage as HTMLElement).querySelector('.remove-image') as HTMLElement;

      (productImage as HTMLElement).addEventListener('drop', (event) => {
        event.preventDefault();
        const file = (event.dataTransfer as DataTransfer).files[0];
        const dt = new DataTransfer();
        dt.items.add(file);
        fileInput.files = dt.files;
        fileInput.dispatchEvent(new Event('change'));
      });

      (productImage as HTMLElement).addEventListener('dragover', (event) => {
        event.preventDefault();
        (event.dataTransfer as DataTransfer).dropEffect = 'copy';
      });

      (productImage as HTMLElement).addEventListener('dragleave', (event) => {
        event.preventDefault();
      });

      (productImage as HTMLElement).addEventListener('click', (e) => {
        if ((e.target as HTMLElement).classList.contains('remove-image')) {
          return;
        }
        if ((e.target as HTMLElement).tagName == 'INPUT') {
          return;
        }
        if ((e.target as HTMLElement).classList.contains('no-content')) {
          // 画像が保存されていない場合、画像選択を表示する
          const productImageFileInput = (productImage as HTMLElement).querySelector('input') as HTMLInputElement;
          productImageFileInput.click();
          return;
        }
        const storeProductId = (productImage as HTMLElement).dataset.storeProductId;
        const productId = (productImage as HTMLElement).dataset.productId;
        const imageUrl = (productImage as HTMLElement).dataset.imageUrl;
        const storeProductName = (productImage as HTMLElement).dataset.storeProductName;
        updateStoreProductModal.style.display = 'block';
        // 必要なdata属性をセットする
        updateStoreProductModal.dataset.storeProductId = storeProductId;
        updateStoreProductModal.dataset.productId = productId;
        updateStoreProductModal.dataset.imageUrl = imageUrl;
        updateStoreProductModal.dataset.storeProductName = storeProductName;
        updateStoreProductModal.dispatchEvent(new Event('open'));
      });

      fileInput.addEventListener('change', () => {
        const files = fileInput.files;
        if (files) {
          const file = files[0];
          if (file) {
            // 必要な属性値をセットする
            const storeProductId = (productImage as HTMLElement).dataset.storeProductId;
            updateStoreProductModal.dataset.storeProductId = storeProductId;
            if (cropperModal) {
              cropperModal.dispatchEvent(new Event('open'));
            } else {
              uploadFile(productImage as HTMLElement, file);
            }
          }
        }
      });

      fileInput.addEventListener('cropped', () => {
        const files = fileInput.files;
        if (files) {
          const file = files[0];
          if (file) {
            uploadFile(productImage as HTMLElement, file);
          }
        }
      });

      removeImageButton.addEventListener('click', () => {
        if (confirm('本当に画像を削除しますか?')) {
          removeImage(productImage as HTMLElement);
        }
      });

      (productImage as HTMLElement).addEventListener('updateProductId', () => {
        const productNanme = (productImage as HTMLElement).dataset.updateProductName;
        if (productNanme && productNanme.length && confirm(productNanme + 'に変更しますか？')) {
          // モーダルが出ている場合は非表示にする
          hideUpdateStoreProductModal();
          const productId = (productImage as HTMLElement).dataset.updateProductId
          const storeProductId = (productImage as HTMLElement).dataset.storeProductId;
          const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
          showProductImageLoader((productImage as HTMLElement));
          addUploadingClass((productImage as HTMLElement));

          axios
            .patch<resultStoreProduct>('/staff/api/store_products/' + storeProductId, { chirashiru_product_id: productId }, {
              headers: {
                'X-CSRF-Token': token
              }
            })
            .then(response => {
              const data = response.data;
              if (data['result'] != 'failed') {
                // アップロード成功
                const imageUrl = data['result'];
                updateProductImageUrl((productImage as HTMLElement), imageUrl);
              } else {
                // アップロード失敗
                alert('アップロードに失敗しました');
              }
              hideProductImageLoader((productImage as HTMLElement));
              removeUploadingClass((productImage as HTMLElement));
            }).catch(error => {
              // 単品商品の紐づく商品マスターの更新でのエラー
              const errorPath = '/staff/api/store_products/' + storeProductId;
              const errorMessage = '単品商品の紐づく商品マスターの更新でエラー発生';

              // エラー送信
              sendError(errorPath, errorMessage)

              alert('アップロードに失敗しました');
              hideProductImageLoader((productImage as HTMLElement));
              removeUploadingClass((productImage as HTMLElement));
            });
        }
      });

      (productImage as HTMLElement).addEventListener('updateImageGalleryId', () => {
        const imageGalleryNanme = (productImage as HTMLElement).dataset.updateImageGalleryName;
        if (imageGalleryNanme && imageGalleryNanme.length && confirm(imageGalleryNanme + 'に変更しますか？')) {
          // モーダルが出ている場合は非表示にする
          hideUpdateStoreProductModal();
          const imageGalleryId = (productImage as HTMLElement).dataset.updateImageGalleryId;
          const storeProductId = (productImage as HTMLElement).dataset.storeProductId;
          const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
          showProductImageLoader((productImage as HTMLElement));
          addUploadingClass((productImage as HTMLElement));

          axios
            .patch<resultStoreProduct>('/staff/api/store_products/' + storeProductId + '/update_image_from_gallery', { chirashiru_store_product_image_gallery_id: imageGalleryId }, {
              headers: {
                'X-CSRF-Token': token
              }
            })
            .then(response => {
              const data = response.data;
              if (data['result'] != 'failed') {
                // アップロード成功
                const imageUrl = data['result'];
                updateProductImageUrl((productImage as HTMLElement), imageUrl);
              } else {
                // アップロード失敗
                alert('アップロードに失敗しました');
              }
              hideProductImageLoader((productImage as HTMLElement));
              removeUploadingClass((productImage as HTMLElement));
            }).catch(error => {
              // 単品商品の紐づく商品マスターの更新でのエラー
              const errorPath = '/staff/api/store_products/' + storeProductId + '/update_image_from_gallery';
              const errorMessage = '単品商品ギャラリーを用いた画像更新でエラー発生';

              // エラー送信
              sendError(errorPath, errorMessage)

              alert('アップロードに失敗しました');
              hideProductImageLoader((productImage as HTMLElement));
              removeUploadingClass((productImage as HTMLElement));
            });
        }
      });
    });
  };

  const showProductImageLoader = (productImage: HTMLElement) => {
    const loader = productImage.querySelector('.product-image-loader') as HTMLElement;
    loader.style.display = 'block';
  }

  const hideProductImageLoader = (productImage: HTMLElement) => {
    const loader = productImage.querySelector('.product-image-loader') as HTMLElement;
    loader.style.display = 'none';
  }

  const addUploadingClass = (productImage: HTMLElement) => {
    productImage.classList.add('product-image-uploading');
  }

  const removeUploadingClass = (productImage: HTMLElement) => {
    productImage.classList.remove('product-image-uploading');
  }

  const updateProductImageUrl = (productImage: HTMLElement, imageUrl: string) => {
    const image = productImage.querySelector('.product-image-tag') as HTMLImageElement;
    image.src = imageUrl;
    refreshProductImages();
  }

  const refreshProductImages = () => {
    const productImages = document.querySelectorAll('td.product-image');
    productImages.forEach(productImage => {
      const image = productImage.querySelector('.product-image-tag') as HTMLImageElement;
      const imageSrc = image.getAttribute('src');
      const imageNoContent = productImage.querySelector('.no-content') as HTMLElement;
      const imageCaution = productImage.querySelector('.caution') as HTMLElement;
      const removeImageButton = productImage.querySelector('.remove-image') as HTMLElement;
      const editCover = productImage.querySelector('.edit-cover') as HTMLElement;
      if (imageSrc == '') {
        image.style.display = 'none';
        imageNoContent.style.display = 'inline-block';
        imageCaution.style.display = 'none';
        removeImageButton.style.display = 'none';
        editCover.style.display = 'none';
      } else {
        image.style.display = 'block';
        imageNoContent.style.display = 'none';
        imageCaution.style.display = 'block';
        removeImageButton.style.display = 'block';
        editCover.style.display = 'block';
      }
    });
  };

  const hideUpdateStoreProductModal = () => {
    updateStoreProductModal.style.display = 'none';
  };

  // 画像をアップロードして保存する
  const uploadFile = (productImage: HTMLElement, file: File) => {
    if (file && confirm(file.name + 'をアップロードしますか？')) {
      // モーダルが出ている場合は非表示にする
      hideUpdateStoreProductModal();
      const storeProductId = productImage.dataset.storeProductId;
      const croppedImageInput = productImage.querySelector('#cropped_image_' + storeProductId) as HTMLInputElement;
      const formData = new FormData();
      formData.append('image', file);
      formData.append('cropped_image', croppedImageInput.value);
      // クロップ画像を空にする
      croppedImageInput.value = '';
      const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
      showProductImageLoader(productImage);
      addUploadingClass(productImage);
      axios
        .patch<resultStoreProduct>('/staff/api/store_products/' + storeProductId + '/update_image', formData, {
          headers: {
            'content-type': 'multipart/form-data',
            'X-CSRF-Token': token
          }
        })
        .then(response => {
          const data = response.data;
          if (data['result'] != 'failed') {
            // アップロード成功
            const imageUrl = data['result'];
            updateProductImageUrl(productImage, imageUrl);
          } else {
            // アップロード失敗
            alert('アップロードに失敗しました');
          }
          hideProductImageLoader(productImage);
          removeUploadingClass(productImage);
        }).catch(error => {
          // エラーで使う変数
          const errorPath = '/staff/api/store_products/' + storeProductId + '/update_image';
          const errorMessage = '単品商品の画像更新でエラー発生';

          // エラー送信
          sendError(errorPath, errorMessage)

          alert('アップロードに失敗しました');
          hideProductImageLoader(productImage);
          removeUploadingClass(productImage);
        });
    }
  };

  // 保存されている画像の削除
  const removeImage = (productImage: HTMLElement) => {
    const storeProductId = productImage.dataset.storeProductId;
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    showProductImageLoader(productImage);
    addUploadingClass(productImage);
    axios
      .patch<resultStoreProduct>('/staff/api/store_products/' + storeProductId + '/remove_image', {}, {
        headers: {
          'X-CSRF-Token': token
        }
      })
      .then(response => {
        const data = response.data;
        if (data['result'] != 'failed') {
          // 削除成功
          updateProductImageUrl(productImage, '');
        } else {
          // 削除失敗
          alert('画像の削除に失敗しました');
        }
        hideProductImageLoader(productImage);
        removeUploadingClass(productImage);
      }).catch(error => {
        // エラーで使う変数
        const errorPath = '/staff/api/store_products/' + storeProductId + '/remove_image';
        const errorMessage = '単品商品の画像削除でエラー発生';

        // エラー送信
        sendError(errorPath, errorMessage)

        alert('画像の削除に失敗しました');
        hideProductImageLoader(productImage);
        removeUploadingClass(productImage);
      });
  };

  // エクセル単位で全てを取得する
  const indexForGroupDiv = document.getElementById('store_products_index_for_group');
  if (indexForGroupDiv != null) {
    const storeProductGroups = document.querySelectorAll<HTMLElement>('.table-for-store-product-group');
    storeProductGroups.forEach(storeProductGroup => {
      const storeProductGroupMore = storeProductGroup.querySelector('.store-product-group-more') as HTMLElement;
      if (storeProductGroupMore && storeProductGroupMore.dataset.status != 'loading') {
        storeProductGroupMore.addEventListener('click', () => {
          const storeProductGroupId = storeProductGroup?.dataset.storeProductGroupId;
          const storeProductIds = (storeProductGroup?.dataset.storeProductIds || '').split(',');
          const params = {
            chirashiru_store_product_group_id: storeProductGroupId,
            displayed_store_product_ids: storeProductIds
          }
          const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
          // 通信中にする
          storeProductGroupMore.dataset.status = 'loading';
          storeProductGroupMore.querySelector('span')?.remove();
          const loading = storeProductGroupMore.querySelector('.store-product-group-loading') as HTMLElement;
          loading.style.display = 'block';
          if (storeProductIds.length) {
            axios
              .post<string>('/staff/api/store_products/index_with_table', params, {
                headers: {
                  'X-CSRF-Token': token
                }
              })
              .then(response => {
                const data = response.data;
                renderStoreProductsOfGroup(storeProductGroup, data);
                storeProductGroupMore.remove();
              }).catch(error => {
                // エラーで使う変数
                const errorPath = '/staff/api/store_products/index_with_table';
                const errorMessage = '単品商品のエクセル投稿一覧で、エクセル単位の単品商品の取得でエラーが発生';

                // エラー送信
                sendError(errorPath, errorMessage)
              });
          }
        });
      }
    });

    const renderStoreProductsOfGroup = (storeProductGroupDiv: HTMLElement, htmlStr: string) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlStr, "text/html");
      const scrollTableDiv = doc.querySelector('.scroll-table');
      const table = storeProductGroupDiv.querySelector('table');
      const tbody = table?.querySelector('tbody');
      const insertedTrs = doc.querySelector('tbody')?.querySelectorAll('tr');
      const checkboxes = doc.querySelectorAll('.store-product-id-check-box');
      // イベントを発行
      const productImages = doc.querySelectorAll('td.product-image');
      addEventToProductImages(productImages);
      const checkBoxTds = doc.querySelectorAll('td.check-box');
      addEventToCheckBoxTds(checkBoxTds);
      addEventToAllCheckBoxesForToggleBulkToolbars(checkboxes);
      // 画像処理
      productImageForIndexClient.initialize(scrollTableDiv as HTMLElement);
      productImageCropForIndexClient.initialize(scrollTableDiv as HTMLElement);
      // 書き込む
      insertedTrs?.forEach(insertedTr => {
        tbody?.append(insertedTr);
      });
      // リフレッシュ
      refreshProductImages();
      // 店舗情報を読み込む
      storeBadgesClient.initialize(storeProductGroupDiv);
      // 全てにチェックされていたら、チェックをいれる
      const allCheckBox = storeProductGroupDiv.querySelector('.all-check-for-store-product-ids');
      (allCheckBox as HTMLElement).addEventListener('change', () => {
        toggleAllCheckBoxes((allCheckBox as HTMLElement), checkboxes);
      });
      toggleAllCheckBoxes((allCheckBox as HTMLElement), checkboxes);
      // 全項目の表示/非表示
      addEventToTableColumnToggle(storeProductGroupDiv);
      initializeTableColumnToggle(storeProductGroupDiv);
      toggleBulkToolbars();
    }
  };

  const sendError = (errorPath: string, errorMessage: string) => {
    // エラーで使う変数
    const el = document.querySelector<HTMLElement>('#staff_infomation');
    const staffId = el?.dataset.staffId;
    const now = el?.dataset.now;

    // エラーイベントを送信 (GA)
    if(staffId && now) {
      googleAnalyticsClient.error({
        time: now,
        path: errorPath,
        staffId: staffId,
        message: errorMessage
      });
    }

    // エラーイベントを送信 (KARTE)
    karteErrorClient.error({
      path: errorPath,
      message: errorMessage
    });
  }

  const initialize = () => {
    toggleBulkToolbars();
    refreshProductImages();
    addEventToProductImages(productImages);
    addEventToCheckBoxTds(checkBoxTds);
    addEventToCheckBoxThs(checkBoxThs);
    addEventToAllCheckBoxes();
    addEventToTableColumnToggles();
    productImageForIndexClient.initialize(indexDiv);
    storeBadgesClient.initialize(indexDiv);
    productImageCropForIndexClient.initialize(indexDiv);
  }

  // 初期実行
  initialize();
});
